import { Reveal } from "./Reveal";
import {
  Rocket,
  FileCheck2,
  Radio,
  Users,
  ShieldCheck,
  ClipboardCheck,
  BookOpen,
  BarChart3,
  ChevronRight,
} from "lucide-react";

const services = [
  {
    icon: Rocket,
    title: "Company Launch",
    text: "Help coordinate the foundation needed to establish the trucking operation.",
  },
  {
    icon: FileCheck2,
    title: "Carrier & Authority Setup",
    text: "Coordination surrounding entity setup, operating authority, USDOT/MC requirements and carrier launch.",
  },
  {
    icon: Radio,
    title: "Dispatch",
    text: "Load sourcing, broker communication, negotiations and load coordination.",
  },
  {
    icon: Users,
    title: "Driver Management",
    text: "Driver onboarding, scheduling, coordination and day-to-day operational communication.",
  },
  {
    icon: ShieldCheck,
    title: "Compliance",
    text: "Ongoing coordination involving DOT requirements, driver files, MVRs, drug and alcohol requirements and carrier compliance.",
  },
  {
    icon: ClipboardCheck,
    title: "Settlement Reconciliation",
    text: "Loads and rate confirmations organized and reconciled so ownership has visibility into operations.",
  },
  {
    icon: BookOpen,
    title: "Bookkeeping Coordination",
    text: "Organized financial information and coordination with the owner's accounting professionals.",
  },
  {
    icon: BarChart3,
    title: "Monthly Reporting",
    text: "Operating performance, dispatch metrics and business reporting delivered to ownership.",
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-[#0A0A0A] py-24 md:py-32 border-y border-neutral-800">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="services-eyebrow">
            What We Handle
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white max-w-3xl"
            data-testid="services-headline"
          >
            The Business Behind The Truck.
          </h2>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-300" data-testid="services-subheadline">
            Owning a trucking company involves much more than buying a truck. I Stay Trucking helps
            manage the operating infrastructure behind the business.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="services-grid">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={0.05 * i}>
              <div
                data-testid={`service-card-${i}`}
                className="group h-full border border-neutral-800 bg-[#121212] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/70"
              >
                <s.icon size={30} className="text-orange-500" strokeWidth={1.75} />
                <h3 className="mt-6 font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-neutral-400">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14">
            <a
              href="#get-started"
              data-testid="services-cta"
              className="inline-flex items-center gap-2 bg-orange-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
            >
              Talk To An Operator
              <ChevronRight size={20} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
